<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import BranchForm from '../BranchForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    BranchForm,
    PageHeader,
    Spinner,
  },
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    branchData() {
      const { branchId } = this.$route.params;
      return this.$store.getters['branches/getBranch'](branchId);
    },
    showBranchForm() {
      const { id } = this.branchData;
      return id && !this.uiFlags.isFetching;
    },
    ...mapGetters({
      uiFlags: 'branches/getUIFlags',
    }),
  },
  methods: {
    async updateBranch(data) {
      try {
        const { branchId } = this.$route.params;

        await this.$store.dispatch('branches/update', {
          id: branchId,
          ...data,
        });

        useAlert(this.$t('BRANCHES_SETTINGS.EDIT_FLOW.API.SUCCESS_MESSAGE'));
        router.push({
          name: 'settings_branches_list',
        });
      } catch (error) {
        useAlert(this.$t('BRANCHES_SETTINGS.EDIT_FLOW.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-y-auto">
    <PageHeader
      :header-title="$t('BRANCHES_SETTINGS.EDIT_FLOW.TITLE')"
      :header-content="$t('BRANCHES_SETTINGS.EDIT_FLOW.DESC')"
    />
    <div class="flex flex-wrap">
      <BranchForm
        v-if="showBranchForm"
        :on-submit="updateBranch"
        :submit-in-progress="false"
        :submit-button-text="$t('BRANCHES_SETTINGS.EDIT_FLOW.SUBMIT')"
        :form-data="branchData"
      />
      <Spinner v-else />
    </div>
  </div>
</template>
